import {
  BenefitCategory,
  ManualBenefitCategory,
} from "types/Models/estimatedTax";

export const MANUAL_BENEFIT_CATEGORY_COPY: Record<
  ManualBenefitCategory,
  {
    modalTitle: string;
    amountLabel: string;
    yearLabel: string;
    submitLabel: string;
    successMessage: string;
  }
> = {
  NOL: {
    modalTitle: "Add a business loss",
    amountLabel: "Loss amount",
    yearLabel: "Tax year of loss",
    submitLabel: "Add loss",
    successMessage: "New loss recorded",
  },
  TAX_OVERPAYMENT: {
    modalTitle: "Add a tax overpayment",
    amountLabel: "Overpayment amount",
    yearLabel: "Tax year of overpayment",
    submitLabel: "Add overpayment",
    successMessage: "New overpayment recorded",
  },
  BUSINESS_ASSETS: {
    modalTitle: "Add a business asset",
    amountLabel: "Depreciation amount",
    yearLabel: "Tax year of asset",
    submitLabel: "Add asset",
    successMessage: "New asset recorded",
  },
};

/** Breakdown table's amount-column header, per benefit category. */
export const BENEFIT_BREAKDOWN_AMOUNT_COLUMN_LABEL: Record<
  BenefitCategory,
  string
> = {
  NOL: "Loss recorded",
  RND_EXPENSES: "Amount recorded",
  TAX_OVERPAYMENTS: "Overpayment recorded",
  BUSINESS_ASSETS: "Amount recorded",
};

export const BENEFIT_BREAKDOWN_SOURCE_SETTINGS = "SETTINGS" as const;
export const BENEFIT_BREAKDOWN_SOURCE_MANUAL = "MANUAL" as const;
export const BENEFIT_BREAKDOWN_SOURCE_RETURN_EXTRACTION =
  "RETURN_EXTRACTION" as const;
export const BENEFIT_BREAKDOWN_SOURCE_RND_BIFURCATION =
  "RND_BIFURCATION" as const;
export const BENEFIT_BREAKDOWN_SOURCE_TAX_BENEFITS = "TAX_BENEFITS" as const;

export const DELETE_VARIANT_BENEFIT_ENTRY = "BENEFIT_ENTRY" as const;
export const DELETE_VARIANT_S174_BENEFIT_ENTRY = "S174_BENEFIT_ENTRY" as const;
export const DELETE_VARIANT_S174_ENTRY = "S174_ENTRY" as const;

export const RND_EXPENSES_CATEGORY = "RND_EXPENSES" as const;

export const TAX_RETURN_UPLOAD_ACCEPT = { "application/pdf": [] };
export const TAX_RETURN_UPLOAD_ERROR_FALLBACK =
  "We couldn't upload your return. Please try again.";

export const UPLOAD_RETURN_STEP_UPLOAD = "UPLOAD" as const;
export const UPLOAD_RETURN_STEP_CONFIRM_REPLACE = "CONFIRM_REPLACE" as const;
export const UPLOAD_RETURN_STEP_RESOLVE_CONFLICT = "RESOLVE_CONFLICT" as const;

export const HTTP_STATUS_NOT_FOUND = 404;
export const HTTP_STATUS_PAYLOAD_TOO_LARGE = 413;

export const TAX_RETURN_FILE_TOO_LARGE_ERROR =
  "File too large. Please upload a PDF under 100MB.";

export const RND_STATUS_POPULATED = "POPULATED" as const;
export const RND_STATUS_CONFLICT = "CONFLICT" as const;

/** Source name used in the toast after the user keeps the existing R&D amount. */
export const RND_KEPT_STATUS_LABEL = {
  KEPT_SETTINGS: "Settings",
  KEPT_BOOKS: "books",
} as const;

export const RND_CONFLICT_RESOLUTION_RETURN = "RETURN" as const;
export const RND_CONFLICT_SOURCE_SETTINGS = "SETTINGS" as const;
export const RND_CONFLICT_SOURCE_BOOKS = "BOOKS" as const;

/** Maps each benefit category to the manual-entry category used by the
 * generic add-entry modal, or null if it has its own dedicated flow. */
export const MANUAL_CATEGORIES: Record<
  BenefitCategory,
  ManualBenefitCategory | null
> = {
  NOL: "NOL",
  TAX_OVERPAYMENTS: "TAX_OVERPAYMENT",
  BUSINESS_ASSETS: "BUSINESS_ASSETS",
  RND_EXPENSES: null,
};
